import { useEffect, useState } from "react";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { showSuccess } from "../../utils/alert";
import { useNavigate } from "react-router-dom";

export default function SettingsPage() {

    const [environment, setEnvironment] = useState("production");
    const [nationality, setNationality] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (typeof window !== "undefined") {
            setEnvironment(localStorage.getItem("rkfl_environment") || "production");
            setNationality(JSON.parse(localStorage.getItem("rkfl_nationality") || "[]"));
        }
    }, []);

    function saveSettings() {
        if (typeof window !== "undefined") {
            localStorage.setItem("rkfl_environment", environment);
            localStorage.setItem("rkfl_nationality", JSON.stringify(nationality));
            localStorage.removeItem('uuid');
            localStorage.removeItem('access');
            // Dispatch custom event to notify other components
            window.dispatchEvent(new CustomEvent('localStorageChange'));
            showSuccess("Settings saved!");
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        }
    }


    function clearCache() {
        if (typeof window !== "undefined") {
            const env = localStorage.getItem("rkfl_environment") || "production";
            const nationality = localStorage.getItem("rkfl_nationality");
            localStorage.clear();
            localStorage.setItem("rkfl_environment", env);
            if (nationality) {
                localStorage.setItem("rkfl_nationality", nationality);
            } else {
                localStorage.setItem("rkfl_nationality", JSON.stringify([]));
            }
            window.location.reload();
        }
    }

    function resetVerification() {
        if (typeof window !== "undefined") {
            localStorage.removeItem("verified");
            localStorage.removeItem('uuid');
            showSuccess("Reset Complete!");
        }
    }

    function handleNationalityChange(e) {
        const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
        setNationality(selectedOptions);
    }
    return (
        <div>
            <nav className="navbar">
                <div className="brand-title">🎬 StreamFlix</div>
            </nav>

            <div className="settings-card">
                <h2>Plugin Settings</h2>
                <div className="mt-3 mb-3">
                    <button onClick={() => navigate('/')} className="btn btn-outline-primary rounded-pill">
                        <FontAwesomeIcon icon={faArrowLeft} /> &nbsp; Back to Home
                    </button>
                </div>

                <form onSubmit={(e) => { e.preventDefault(); saveSettings(); }}>
                    <label>Environment</label>
                    <select value={environment} onChange={(e) => setEnvironment(e.target.value)}>
                        <option value="production">Production</option>
                        <option value="sandbox">Sandbox</option>
                    </select>

                    <label className="mt-2">Nationality</label>
                    <select 
                        id="nationality" 
                        multiple 
                        size="8" 
                        value={nationality} 
                        onChange={handleNationalityChange}
                    >
                        <option value="US">United States</option>
                        <option value="CA">Canada</option>
                        <option value="GB">United Kingdom</option>
                        <option value="AU">Australia</option>
                        <option value="NZ">New Zealand</option>
                        <option value="IE">Ireland</option>
                        <option value="DE">Germany</option>
                        <option value="FR">France</option>
                        <option value="ES">Spain</option>
                        <option value="IT">Italy</option>
                        <option value="NL">Netherlands</option>
                        <option value="BE">Belgium</option>
                        <option value="CH">Switzerland</option>
                        <option value="AT">Austria</option>
                        <option value="SE">Sweden</option>
                        <option value="NO">Norway</option>
                        <option value="DK">Denmark</option>
                        <option value="FI">Finland</option>
                        <option value="PL">Poland</option>
                        <option value="CZ">Czech Republic</option>
                        <option value="HU">Hungary</option>
                        <option value="RO">Romania</option>
                        <option value="BG">Bulgaria</option>
                        <option value="GR">Greece</option>
                        <option value="TR">Turkey</option>
                        <option value="SA">Saudi Arabia</option>
                        <option value="AE">United Arab Emirates</option>
                        <option value="QA">Qatar</option>
                        <option value="KW">Kuwait</option>
                    </select>
                    <small style={{color: "#63636f", fontSize: "0.9em", display: "block", marginTop: "5px"}}>
                        Hold Ctrl (Cmd on Mac) to select multiple nationalities
                    </small>

                    <button type="submit" className="btn btn-primary mt-3">Save Settings</button>
                </form>


                <div className="d-flex justify-content-between">
                    <button className="btn btn-danger mt-3" onClick={clearCache}>Clear Cache</button>
                    <button className="btn btn-warning mt-3" onClick={resetVerification}>Reset verification</button>
                </div>

            </div>
        </div>
    );
}
